import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

interface BankIdLaunchPanelProps {
  /** Which BankID flavour this is, as a badge above the button. */
  badge: string;
  buttonLabel: string;
  hint: string;
  /** Opened in a new tab when the button is pressed. */
  url: string;
}

/** The "open BankID" call to action shown when the bank hands back a launch URL. */
export function BankIdLaunchPanel({ badge, buttonLabel, hint, url }: BankIdLaunchPanelProps) {
  return (
    <div className="space-y-4">
      <div className="text-center">
        <Badge variant="outline" className="mb-2">{badge}</Badge>
      </div>
      <Button onClick={() => window.open(url, "_blank")} className="w-full" size="lg">
        {buttonLabel}
      </Button>
      <p className="text-xs text-muted-foreground text-center">{hint}</p>
    </div>
  );
}
